import React from 'react';
import { Route } from 'react-router-dom';
import Helpers from 'components/helpers';

const routes = [
  <Route key="helpers" path="/helpers" exact><Helpers/></Route>
];

export default routes;
